import { render, staticRenderFns } from "./newOrders.vue?vue&type=template&id=e54632de&"
import script from "./newOrders.vue?vue&type=script&lang=js&"
export * from "./newOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports